import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=5fda38be"
import script from "./Img.vue?vue&type=script&lang=js"
export * from "./Img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports